<template>
    <div style="background: #210F03CC; z-index: 100; position: fixed; top: 0; left: 0; width: 100%; height: 100%;">
        <div v-if="is_loaded" style="color: #fff; padding: 12px; height: 100%; display: flex; flex-direction: column;">
            <div style="display: flex; position: relative; align-items: center; margin-top: 15vh;">
                <div @click="handleCloseWriteForm(false)">
                    <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                </div>
                <div v-if="writeType === WRITE_TYPE.REVIEW" style="text-align: center; flex: 1; position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700; line-height: 24px;">팀 트레이닝은 어떠셨나요?<br>리뷰를 남겨주세요!</div>
                <div v-else-if="writeType === WRITE_TYPE.HISTORY && !isShowWriteHistory" style="text-align: center; flex: 1; position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700; line-height: 24px; top: 0;">트레이닝이 끝났습니다!<br>이번주 트레이닝에서는<br>어떤 훈련을 진행했나요?</div>
            </div>
            <Transition name="fade" v-if="!isShowWriteHistory">
                <div class="hide_scroll" style="margin-top: 20px; padding-bottom: 40px; flex: 1; position: relative; z-index: 10; overflow-y: scroll; overflow-x: hidden;">
                    <div v-if="prev_history" :style="{ marginTop: writeType === WRITE_TYPE.REIVEW ? '' : '50px' }" style="font-size: 14px; font-weight: 700;">{{ writeType === WRITE_TYPE.HISTORY ? $Util.getMDDHangulStr(scheduleDetail.join_begin_date_time) : $Util.getMDDHangulStr(prev_history.history_date) }} 히스토리</div>
                    <div v-if="writeType === WRITE_TYPE.REVIEW" class="hide_scroll" style="display: flex; padding: 0 12px; padding-top: 12px; padding-bottom: 20px; margin: 0 -12px; gap: 12px; overflow-x: scroll;">
                        <template v-for="each, i in historyImage">
                            <div v-if="prev_history && prev_history['thumb_image_path' + i]" :key="i" style="height: 200px; width: 200px; border: 1px solid #808080; border-radius: 12px; flex-shrink: 0;">
                                <img style="height: 100%; width: 100%; object-fit: cover; border-radius: 12px;" :src="$resourcePath + prev_history['thumb_image_path' + i]" alt="">
                            </div>
                        </template>

                        <!--<div style="height: 200px; width: 200px; border: 1px solid #808080; border-radius: 12px; flex-shrink: 0;">-->
                        <!--<img style="height: 100%; width: 100%; object-fit: cover; border-radius: 12px;" :src="require('@/assets/img/배예린.jpg')" alt="">-->
                        <!--</div>-->
                        <!--<div style="height: 200px; width: 200px; border: 1px solid #808080; border-radius: 12px; flex-shrink: 0;">-->
                        <!--<img style="height: 100%; width: 100%; object-fit: cover; border-radius: 12px;" :src="require('@/assets/img/배예린.jpg')" alt="">-->
                        <!--</div>-->
                        <!--<div style="height: 200px; width: 200px; border: 1px solid #808080; border-radius: 12px; flex-shrink: 0;">-->
                        <!--<img style="height: 100%; width: 100%; object-fit: cover; border-radius: 12px;" :src="require('@/assets/img/배예린.jpg')" alt="">-->
                        <!--</div>-->
                    </div>
                    <div class="hide_scroll" style="padding: 0 12px; padding-top: 16px; display: flex; padding-bottom: 20px; margin: 0 -12px; gap: 12px; overflow-x: scroll;" v-else>
                        <div @click="showFiles(i)" v-for="each, i in historyImage" :key="i" style="">
                            <div style="text-align: center; margin-bottom: 12px; font-weight: 700; font-size: 12px;">{{ each.title }} <span :style="{ color: each.require ? 'var(--color-main)' : '' }">{{ each.subTitle }}</span></div>
                            <div style="display: flex;">
                                <div style="height: 200px; width: 200px; border: 1px solid #808080; border-radius: 12px; flex-shrink: 0; display: flex; justify-content: center; background: #210F034D;">
                                    <div v-if="!imgSrcArr['file' + i]" style="display: flex; gap: 6px; flex-direction: column; justify-content: center; align-items: center;">
                                        <div>
                                            <img style="width: 32px;" :src="require('@/assets/img/add_picture.png')" alt="">
                                        </div>
                                        <div style="font-size: 12px; font-weight: 700;">사진 추가</div>
                                    </div>
                                    <div style="position: relative;" v-else>
                                        <img style="width: 200px; height: 200px; object-fit: cover; border-radius: 12px;" :src="imgSrcArr['file' + i].src" alt="">
                                        <div @click.stop="deleteImg(i, 'file' + i)" style="position:absolute; right:0px; bottom: 0px; padding:5px;">
                                            <img :src="require('@/assets/img/rounded_trash_can.png')" style="width:40px; height:40px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; gap: 20px;">
                        <div style="width: 60px; height: 60px;">
                            <ProfileImage style="width: 100%; height: 100%;" :image-path="my_image" :isShowBorder="false"></ProfileImage>
                        </div>
                        <div v-if="writeType === WRITE_TYPE.REVIEW" style="border-radius: 12px; background-color: #fff; position: relative; max-height: 112px; padding: 8px 12px; color: #210f03; font-weight: 500; max-width: 265px;">
                            <div style="position: absolute; z-index: -1; left: -12px; top: 0;">
                                <img style="width: 40px;" :src="require('@/assets/img/ballon_triangle.png')" alt="">
                            </div>
                            <div v-if="prev_history" style="font-size: 14px; line-height: 24px;">{{ prev_history.history_date ? $Util.getMMDDDayHangulStr(prev_history.history_date) : '' }}</div>
                            <div v-if="prev_history" class="ellipsis" style="font-size: 14px; color: #606060; line-height: 24px; ">{{ prev_history.contents }}</div>
                        </div>
                        <div @click="writeHistory" v-else style="border-radius: 12px; background-color: #fff; position: relative; max-height: 123px; padding: 8px 12px; color: #210f03; font-weight: 500; max-width: 265px;">
                            <div style="position: absolute; z-index: -1; left: -12px; top: 0;">
                                <img style="width: 40px;" :src="require('@/assets/img/ballon_triangle.png')" alt="">
                            </div>
                            <div style="font-size: 14px; line-height: 24px;">{{ $Util.getMMDDDayHangulStr(scheduleDetail.join_begin_date_time) }}</div>
                            <div class="ellipsis_one" :style="{ color: historyContents.length === 0 ? '#bbbbbb' : '#606060' }" style="font-size: 14px; line-height: 24px; font-size: 14px; font-weight: 500;">{{ historyContents.length === 0 ? '트레이닝 내용과 결과를 입력해주세요.' : historyContents }}</div>
                            <div style="color: #606060; font-size: 12px; margin-top: 14px; font-weight: 500;line-height: 20px;">작성 예시: 워밍업 후 왕복 달리기 / 공격 상황에 따른 움직임 / 6:6 매치를 진행했습니다</div>
                        </div>
                    </div>
                </div>
            </Transition>
            <Transition name="fade" v-else>
                <div style="flex: 1;">
                    <div style="font-size: 14px; font-weight: 700; margin-top: 24px;">{{ $Util.getMMDDDayHangulStr(scheduleDetail.join_begin_date_time) }} 히스토리</div>
                    <div style="display: flex; gap: 20px; margin-top: 16px;">
                        <div style="width: 60px; height: 60px;">
                            <ProfileImage style="width: 100%; height: 100%;" :image-path="my_image" :isShowBorder="false"></ProfileImage>
                        </div>
                        <div @click="writeHistory" style="border-radius: 12px; background-color: #fff; min-height: 183px; position: relative; padding: 8px 12px; color: #210f03; font-weight: 500; max-width: 265px;">
                            <div style="position: absolute; z-index: -1; left: -12px; top: 0;">
                                <img style="width: 40px;" :src="require('@/assets/img/ballon_triangle.png')" alt="">
                            </div>
                            <div style="font-size: 14px; line-height: 24px;">{{ $Util.getMMDDDayHangulStr(scheduleDetail.join_begin_date_time) }}</div>
                            <div style="display: flex; flex-direction: column; justify-content: space-between;">
                                <textarea maxlength="100" v-model="historyContents" @input="test" ref="text_area" placeholder="트레이닝 내용과 결과를 입력해주세요." style="width: 100%; max-height: 200px; min-height: 104px; outline: none; resize: none; border: none; line-height: 24px; font-size: 14px; font-weight: 500;"></textarea>
                                <div style="color: #606060; font-size: 12px; font-weight: 500;line-height: 20px;">작성 예시: 워밍업 후 왕복 달리기 / 공격 상황에 따른 움직임 / 6:6 매치를 진행했습니다</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
            <div style="display:flex; align-items: center;">
                <input type="file" style="display:none;" ref="file0" data-id="file0" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                <input type="file" style="display:none;" ref="file1" data-id="file1" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                <input type="file" style="display:none;" ref="file2" data-id="file2" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                <input type="file" style="display:none;" ref="file3" data-id="file3" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                <input type="file" style="display:none;" ref="file4" data-id="file4" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
            </div>
            <div v-if="writeType === WRITE_TYPE.REVIEW" style="width: 290px; height: 56px; border-radius: 45px; margin: 0 auto; margin-bottom: 30px; background-color: #fff; color: #210f03;">
                <div @click="showReviewWriteForm" style="text-align: center; font-weight: 700; font-size: 14px; line-height: 56px;">트레이닝 리뷰 남기기</div>
            </div>
            <div v-else style="width: 290px; margin-bottom: 40px; height: 56px; border-radius: 45px; margin: 0 auto; margin-bottom: 30px; background-color: #fff; color: #210f03;">
                <div @click="submitHistory" style="text-align: center; font-weight: 700; font-size: 14px; line-height: 56px;">히스토리 작성하기</div>
            </div>
        </div>
        <div style="position: relative; z-index: 10;">
            <CommonPopupFrame :changeHeight="95" :isOpen="isOpenReviewWriteForm" :changeBottom="0" :closeCompleteAction="closeReviewWriteForm">
                <div style="height:20px;">
                    <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
                </div>
                <div style="display:flex; justify-content: space-between; padding: 0 12px; padding-top:10px; position: relative; border-bottom: 1px solid #f5f5f5; padding-bottom: 8px;">
                    <div style="width:80px; text-align:center; display: flex; align-items: center;" @click.stop="closeReviewWriteForm">
                        <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                    </div>
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); text-align: center;">
                        <div style="font-weight:bold; font-size:16px; color:#210F03">리뷰</div>
                        <div style="font-weight:bold; font-size:12px; color:#606060; margin-top:8px">{{ $Util.getYYYMMDDHangulStr(today) }}</div>
                    </div>
                    <div @click="submitReview" :style="{ color: contents.length === 0 ? '#d9d9d9' : '#210f03' }" style="font-weight: 700; margin-top: 4px;">리뷰 작성하기</div>
                </div>
                <div @touchmove.stop="() => { }" style="padding: 0 12px; flex: 1;">
                    <div style="border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                        <textarea v-model="contents" maxlength="200" rows="1" ref="text_area" @input="test" placeholder="내용을 입력하세요" name="" id="" style="resize: none; border: none; line-height: 28px; margin-top: 20px; width: 100%; max-height: 300px; outline: none;"></textarea>
                    </div>
                </div>
            </CommonPopupFrame>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { WRITE_TYPE } from '@/Constants';
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame.vue';
import moment from 'moment'
import ResponseCode from '@/ResponseCode';

export default {
    name: "TeamTrainingWriteForm",
    props: {
        closeWriteForm: {
            type: Function,
            default: null
        },
        scheduleIdx: {
            type: [Number, String],
            default: ''
        },
        getReplyList: {
            type: Function,
            default: () => { }
        },
        writeType: {
            type: String,
            default: WRITE_TYPE.REVIEW
        },
        isShowTeamTrainingDetailWhenSave: {
            type: Boolean,
            default: true,
        },
        refreshTeamTraining: {
            type: Function,
            defualt: () => { }
        }
    },
    computed: {
        my_image() {
            return this.$GlobalStore.loginInfo().image_path
        }
    },
    components: { ProfileImage, CommonPopupFrame },
    data() {
        return {
            isShowWriteHistory: false,
            isOpenReviewWriteForm: false,
            today: '',
            contents: '',
            historyContents: '',
            localCloseWriteForm(isComplete = false) {
                if (this.closeWriteForm) {
                    return this.closeWriteForm(isComplete);
                } else if (this.$GlobalStore.closeLastModal) {
                    return this.$GlobalStore.closeLastModal();
                }
            },
            WRITE_TYPE: WRITE_TYPE,
            historyImage: [
                { title: '워밍업/준비운동 사진', subTitle: '(필수)', require: true },
                { title: '주요 트레이닝 사진', subTitle: '(필수)', require: true },
                { title: '소규모 매치 사진', subTitle: '(필수)', require: true },
                { title: '다른 훈련 사진', subTitle: '(선택)', require: false },
                { title: '멤버 단체사진', subTitle: '(선택)', require: false },
            ],
            imgSrcArr: [],
            prev_history: {},
            coach: {},
            is_loaded: false,
            scheduleDetail: {}
        };
    },
    methods: {
        deleteImg(index, key) {
            this.$refs[this.imgSrcArr['file' + index].id].value = '';
            this.$delete(this.imgSrcArr, key);
        },
        showFiles(index) {
            if (this.imgSrcArr.length >= 5) {
                alert('최대 5개까지 업로드 가능합니다.');
                return;
            }

            for (let i = 0; i < 5; i++) {
                if (this.$refs['file' + index].value === '') {
                    this.$refs['file' + index].click();
                    return;
                }
            }
        },
        async submitHistory() {
            for (let i = 0; i < 3; i++) {
                if (this.$refs['file' + i].value === '') {
                    this.$GlobalStore.showAlert(this.historyImage[i].title + '을 추가해주세요.');
                    return;
                }
            }

            if (this.historyContents === '') {
                this.$GlobalStore.showAlert('히스토리 내용을 입력해주세요.');
                return;
            }

            this.$GlobalStore.showProgress()
            const formData = new FormData()

            formData.append('mode', 'insert')
            formData.append('join_schedule_idx', this.scheduleIdx)
            formData.append('contents', this.historyContents)

            Object.keys(this.imgSrcArr).forEach(item => {
                const curImgSrc = this.imgSrcArr[item];
                console.log(curImgSrc)
                if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                    formData.append('image_' + item, this.$refs[curImgSrc.id].files[0]);
                } else if (!curImgSrc.isFileTag) {
                    formData.append('image_path' + item, curImgSrc.path)
                    formData.append('thumb_image_path' + item, curImgSrc.thumPath)
                }
            })

            const res = await this.$Axios.post('/api/join/schedule/history/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress();
                this.$GlobalStore.closeLastModal();
                if (!this.refreshTeamTraining) {
                    this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: this.scheduleIdx });
                    return
                }
                this.refreshTeamTraining();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.hideProgress();
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const index = input.getAttribute('data-id');  // 인덱스를 가져옴
                        const data = {
                            src: e.target.result,
                            id: index,
                            isFileTag: true,
                            isEnlarge: false,
                            large_width: 0,
                            large_height: 0,
                            default_width: 0,
                            default_height: 0
                        };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.src = require('@/assets/this_is_video.png');

                        // imgSrcArr 배열의 해당 인덱스에 이미지 추가
                        this.$set(this.imgSrcArr, index, data);
                    };
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        writeHistory() {
            this.isShowWriteHistory = true;
        },
        handleCloseWriteForm(isComplete = false) {
            if (this.isShowWriteHistory) {
                this.isShowWriteHistory = false;
                return
            }
            this.localCloseWriteForm(isComplete)

        },
        async submitReview() {
            if (this.contents.length === 0) {
                this.$GlobalStore.showAlert('내용을 작성해주세요')
                return
            }

            const formData = new FormData();
            formData.append('parentIdx', this.scheduleIdx);
            formData.append('contents', this.contents);
            formData.append('type', 'schedule');
            formData.append('mode', 'insert');
            if (this.prev_history.repeat_schedule_idx) formData.append('refer_idx', this.prev_history.repeat_schedule_idx);

            const res = await this.$Axios.post('/api/soccerhow/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeReviewWriteForm();
                this.contents = '';
                this.handleCloseWriteForm(true);
                this.getReplyList();
                if (this.isShowTeamTrainingDetailWhenSave) this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: this.scheduleIdx });
            } else if (res.data.msg === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        showReviewWriteForm() {
            this.isOpenReviewWriteForm = true
        },
        closeReviewWriteForm() {
            this.isOpenReviewWriteForm = false
        },
        test() {
            this.$refs.text_area.style.height = 'auto'
            this.$refs.text_area.style.height = this.$refs.text_area.scrollHeight + 'px'
        },
        async getHitsory() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleIdx;
            const res = await this.$Axios.get('/api/join/schedule/history/one', { params: parameters });
            this.prev_history = res.data.join_schedule_history;
            this.coach = res.data.coach;
            this.is_loaded = true;
        },
        async getScheduleDetail() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleIdx;

            const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters });
            if (!res.data.join_schedules) {
                this.$GlobalStore.showAlert('삭제된 수업입니다.');
                this.$GlobalStore.closeLastModal();
                return
            }
            const scheduleDetail = res.data.join_schedules
            this.scheduleDetail = scheduleDetail
        },
    },
    created() {
        this.submitHistory = this.$Once(this.submitHistory);
        this.submitReview = this.$Once(this.submitReview);

        this.today = moment().format("YYYY-MM-DD");

        if (this.writeType === WRITE_TYPE.REVIEW) {
            this.getHitsory();
        } else {
            this.is_loaded = true;
            this.getScheduleDetail()
        }

    }
};
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.ellipsis_one {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

textarea::placeholder {
    font-weight: 500;
    color: #bbbbbb;
}
</style>
